import { Component, OnInit } from '@angular/core';
import { UserService } from '../shared/user/user-service.service';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.css']
})
export class MyAccountComponent implements OnInit {

  oldPassword: string;
  newPassword: string;
  message = '';

  constructor(private userSerwice: UserService) { }

  ngOnInit() {
  }

  save() {
    this.userSerwice.changePass(this.oldPassword, this.newPassword).subscribe(data => {
      this.message = data.toString();
      this.oldPassword = '';
      this.newPassword = '';
    });
  }
}
